/**
 * Blog Education Center — two interactions:
 *   1. Jump-link active state on tab click.
 *   2. "View more" — AJAX-loads the next paginated page of articles via
 *      Shopify's Section Rendering API and appends them to the grid in
 *      place. Replaces the previous CSS-hide approach that loaded every
 *      article upfront.
 *
 * Loading state is intentionally invisible: button stays labelled "View
 * more" and is briefly disabled during the fetch. Most users will not
 * perceive the ~200–500ms network delay, matching the prior in-place
 * reveal UX as closely as possible.
 */
(function () {
  function initJumpLinks() {
    const jumpLinks = document.querySelectorAll('.jump-link-wrapper a');
    jumpLinks.forEach((link) => {
      link.addEventListener('click', function () {
        jumpLinks.forEach((l) => l.classList.remove('active'));
        this.classList.add('active');
      });
    });
  }

  /**
   * Wire one "View more" button to AJAX-load the next page.
   * @param {HTMLButtonElement} btn
   */
  function wireLoadMore(btn) {
    btn.addEventListener('click', async () => {
      const gridId = btn.dataset.gridId;
      const nextUrl = btn.dataset.nextUrl;
      const sectionId = btn.dataset.sectionId;

      if (!gridId || !nextUrl || !sectionId) return;
      if (btn.dataset.loading === 'true') return;

      // Silent disabled state — no text change, no spinner.
      btn.dataset.loading = 'true';
      btn.disabled = true;

      try {
        // Section Rendering API: append section_id so Shopify returns just
        // this section's HTML rather than the full page.
        const separator = nextUrl.includes('?') ? '&' : '?';
        const fetchUrl = `${nextUrl}${separator}section_id=${sectionId}`;

        const response = await fetch(fetchUrl);
        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');

        // Locate the matching grid in the returned HTML (multi-tab sections
        // contain several grids; we want the one for this tab only).
        const newGrid = doc.querySelector(`[data-grid-id="${gridId}"]`);
        if (!newGrid) throw new Error('Grid not found in section response');

        const currentGrid = document.querySelector(`[data-grid-id="${gridId}"]`);
        if (!currentGrid) throw new Error('Current grid missing from DOM');

        // Append each new card to the existing grid.
        newGrid.querySelectorAll('.blog-item').forEach((card) => {
          currentGrid.appendChild(card);
        });

        // Update next-url for subsequent clicks, or hide button when done.
        const newBtn = doc.querySelector(`.view-more-btn[data-grid-id="${gridId}"]`);
        if (newBtn && newBtn.dataset.nextUrl) {
          btn.dataset.nextUrl = newBtn.dataset.nextUrl;
        } else {
          btn.style.display = 'none';
        }
      } catch {
        // Silent fail — leave button enabled so user can retry.
        // No telemetry endpoint wired yet.
      } finally {
        btn.dataset.loading = 'false';
        btn.disabled = false;
      }
    });
  }

  function init() {
    initJumpLinks();
    document.querySelectorAll('.view-more-btn').forEach(wireLoadMore);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
